import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  cards: [],
  loading: false,
  saving: false,
  currentCard: null,
  logs: [],
  logsLoading: false,
  creatingAccount: false,
  sendingEmail: false,
  comments: [],
  commentsLoading: false,
  savingComment: false,
  userMentions: [],
};

export default function postSaleReducer(state = initState, action) {
  switch (action.type) {
    case authActions.CLEAR_STATES:
      return { ...initState };

    case actions.FETCHING_CARDS:
      return { ...state, loading: true };
    case actions.FETCH_CARDS_SUCCESS:
      return { ...state, cards: action.payload, loading: false };
    case actions.FETCH_CARDS_ERROR:
      return { ...state, cards: [], loading: false };

    case actions.SAVING_CARD:
      return { ...state, saving: true };
    case actions.SAVE_CARD_SUCCESS:
      return { ...state, saving: false, currentCard: null };
    case actions.SAVE_CARD_ERROR:
      return { ...state, saving: false };

    case actions.CREATING_ACCOUNT:
      return { ...state, creatingAccount: true };
    case actions.CREATE_ACCOUNT_SUCCESS:
      return { ...state, creatingAccount: false };
    case actions.CREATE_ACCOUNT_ERROR:
      return { ...state, creatingAccount: false };

    case actions.SENDING_WELCOME_EMAIL:
      return { ...state, sendingEmail: true };
    case actions.SEND_WELCOME_EMAIL_SUCCESS:
      return { ...state, sendingEmail: false };
    case actions.SEND_WELCOME_EMAIL_ERROR:
      return { ...state, sendingEmail: false };

    case actions.FETCHING_COMMENTS:
      return { ...state, commentsLoading: true };
    case actions.FETCH_COMMENTS_SUCCESS:
      return { ...state, comments: action.payload, commentsLoading: false };
    case actions.FETCH_COMMENTS_ERROR:
      return { ...state, comments: [], commentsLoading: false };

    case actions.SAVING_COMMENT:
      return { ...state, savingComment: true };
    case actions.SAVE_COMMENT_SUCCESS:
      return { ...state, savingComment: false };
    case actions.SAVE_COMMENT_ERROR:
      return { ...state, savingComment: false };

    case actions.FETCHING_LOGS:
      return { ...state, logsLoading: true };
    case actions.FETCH_LOGS_SUCCESS:
      return { ...state, logs: action.payload, logsLoading: false };
    case actions.FETCH_LOGS_ERROR:
      return { ...state, logs: [], logsLoading: false };

    case actions.MENTION_RECEIVED: {
      const exists = state.userMentions.some((m) => m.id === action.payload.id);
      if (exists) return state;
      return { ...state, userMentions: [...state.userMentions, action.payload] };
    }
    case actions.DISMISS_MENTION_REQUEST:
      return {
        ...state,
        userMentions: state.userMentions.filter((m) => m.id !== action.payload),
      };

    case actions.SET_CURRENT_CARD:
      return { ...state, currentCard: action.payload };
    case actions.CLEAR_CURRENT_CARD:
      return { ...state, currentCard: null };

    default:
      return state;
  }
}
